export default __webpack_public_path__ + "static/media/http.8042d294.svg";